import type { IPoint } from '@/modules/Editor/point'
import type { ExtendedFileMetadata } from '@/modules/Editor/metadata'
import type { VoxelRasterDimensions } from '@/modules/Editor/models/raster/VoxelRaster'
import { getXYVoxelScaling } from '@/modules/Editor/plugins/brush/utils/getXYVoxelScaling'

export const getPointFromScaledPixel = (
  imagePoint: IPoint,
  metadata?: ExtendedFileMetadata,
  voxelRasterDimensions?: VoxelRasterDimensions,
): IPoint => {
  if (!metadata || !voxelRasterDimensions) {
    return { x: Math.floor(imagePoint.x), y: Math.floor(imagePoint.y) }
  }

  const voxelScaling = getXYVoxelScaling(metadata, voxelRasterDimensions) || {
    x: 1,
    y: 1,
  }

  const point = {
    x: Math.floor(imagePoint.x * voxelScaling.x),
    y: Math.floor(imagePoint.y * voxelScaling.y),
  }

  return point
}
